
import axios from 'axios';
import { BASE_URL } from "src/config/config";
import { toast } from 'react-toastify'

export const fetchTableData = async (currentPage, limit) => {
  try {
    let result = await axios.get(`${BASE_URL}apiBatch/apiBatchTableData`, {
      params: {
        page: currentPage,
        limit: limit
      }
    })

    if (result.status == '200') {
      // console.log(result.data)
      return {
        data: result.data.data,
        currentPage: result.data.currentPage,
        totalPages: result.data.totalPages,
        totalRecords: result.data.totalRecord,
        limit: result.data.limit
      }
    }
  } catch (error) {
    console.log(error)
  }
}

export const Add_Api_To_The_Table = async (requestBody) => {

  try {
    const result = await axios.post(`${BASE_URL}apiBatch/addDataToTable`, {
      "api": requestBody
    });

    if (result.status == '200') {
      console.log(result.data)
      toast.success('API Added.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return result
    }
  } catch (error) {
    console.log(error)
    toast.error("Error Adding API Data", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
  }
}

export const fetchRecordsForPage = async (pageNumber, limit) => {
  try {
    // Assuming you fetch data from an API endpoint
    let response = await axios.get(`${BASE_URL}apiBatch/apiBatchTableData`, {
      params: {
        page: pageNumber,
        limit: limit
      }
    })
    if (response.status == '200') {
      //    console.log(response.data)
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching records:', error);
    return []; // Return empty array if an error occurs
  }
};


export const saveBatch = async (batchName) => {
  try {
    const response = await axios.post(`${BASE_URL}apiBatch/createBatch`, { batchName });

    if (response.status == "200") {
      // console.log(response.data, "============================================")
      toast.success('Batch Added.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return response.data;
    }
  } catch (error) {
    toast.error(error.response.data.message, {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    // throw new Error(error.response.data.message || 'Failed to create batch'); // Throw an error if request fails
  }
};

export const getAllBatches = async (currentPage, limit) => {
  try {
    let response = await axios.get(`${BASE_URL}apiBatch/getBatch`,{
      params: {
        page: currentPage,
        limit: limit
      }
    })
    if (response.status == '200') {
      // console.log(response.data, "data from api calls")
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching records:', error);

  }
}


 export const fetchBatchData = async () => {
    try {
      let allData = [];
      let currentPage = 1;
      let totalPages = 1;

      // Fetch data from all pages
      while (currentPage <= totalPages) {
        const response = await fetch(
          `${BASE_URL}apiBatch/getBatch?page=${currentPage}`
        );
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const { data, totalPages: total } = await response.json();
        allData = [...allData, ...data];
        totalPages = total;
        currentPage++;

      }
      // console.log(allData, "------------------------------")
       return allData;
    } catch (error) {
      setError('Error fetching template data');
    }
  };

export const addingCandidates = async (batchId, candidateIds) => {
    try {
        const response = await axios.post(`${BASE_URL}apiBatch/addTOBatch`, { batchId, candidateIds});
    
        if (response.status == "200") {
          console.log(response.data, "============================================")
          toast.success('Candidates Added to the Batch.', {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          return response.data;
        }
      } catch (error) {
        toast.error(error.response.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
}

export const getAllCandidates = async (currentPage, limit) => {
    try {
        let response = await axios.get(`${BASE_URL}apiBatch/apiBatchTableData`, {
          params: {
            page: currentPage,
            limit: limit
          }
        })
        if (response.status == '200') {
          console.log("........................................", response)
          return response.data;
        }
      } catch (error) {
        console.error('Error fetching records:', error);
        toast.error("Error fetching records", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }   
}

export const deleteCandidates = async (batchId, candidateIds) => {
  try {
    const response = await axios.delete(`${BASE_URL}apiBatch/deleteCandidateFromBatch/${batchId}`, {
        data: { candidateIds }
    });

    return response.data;
} catch (error) {
    console.error('Error deleting candidates:', error);
    throw error;
}
}


